import {
  Box,
  Button as ChakraButton,
  extendTheme,
  Flex,
  HStack,
  Icon,
  IconButton,
  SimpleGrid,
  Spacer,
  Spinner,
  Stack,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useDisclosure,
  useToast,
  Link as ChakraLink,
} from '@chakra-ui/react';
import download from 'downloadjs';
import React, { ReactNode, useContext, useEffect, useState } from 'react';
import Chart from 'react-google-charts';
import { FiDownload, FiInfo } from 'react-icons/fi';
import { Link, useHistory } from 'react-router-dom';
import { Button, Heading, Pagination, StatusBadge, Table } from '~/components';
import { SummaryActivities } from '~/components/SummaryActivities';
import { ALL_FEATURES, PAGE_SIZE, ROUTER_PATHS, STORAGE } from '~/constants';
import { FilterContext } from '~/contexts/FilterContext/FilterContext';
import {
  useApolicesAVencer,
  useClientes,
  useContratos90Dias,
  useContratosAguardandoReajuste,
  useContratosEmAndamento,
  useDebounce,
  useEquipamentosContratados,
  useExternoCan,
  useFaturasEmAtraso,
  useHome,
  useHomeInvoices,
  useInvoices,
  usePieChart,
  useRoleCan,
  useValoresFaturados,
} from '~/hooks';
import {
  getApolicesAVencer,
  getExtensionContractDocument,
  getHomeContacts,
  getHomeContractsXlsx,
} from '~/services';
import { replaceParameters } from '~/utils/replaceParamaters';

import contractImg from '../../assets/contract.png';
import dollarImg from '../../assets/dollar.png';
import paperPenImg from '../../assets/paper-pen.png';
import paperImg from '../../assets/paper.png';
import paperTimeImg from '../../assets/paper-time.png';
import equipamentsImg from '../../assets/equipaments.png';
import { ContactUsCards } from '~/pages/Portal/ContactUsCards';
import { UsersContact } from '~/types/userscontact';
import { Contract, ContractView, StatusExtensaoIdEnum } from '~/types';
import { Shortcut } from '~/components/Shortcut';
import shortcut from '~/assets/shortcut_technical_support.svg';
import { ConfirmationDialog } from '~/components/ConfirmationDialog';
import { InsuranceList } from '~/types/insurance';
import { AnalyseContractExtensionModal } from '~/pages/Portal/Contract/AnalyseContractExtensionModal';
import { useFeatureFlags } from '~/contexts/FeatureFlagsContext/FeatureFlagsContext';

export const Home: React.VFC = () => {
  const [page, setPage] = useState(1);
  const [pageInsurance, setPageInsurance] = useState(1);
  const history = useHistory();
  const features = useFeatureFlags();
  const canSeeInsurances = useRoleCan({
    roles: ['administrador', 'operacional', 'suporte'],
  });
  const userIsOperacional = useRoleCan({ roles: ['operacional'] });
  const externoCan = useExternoCan({ roles: ['cliente'] });
  const internoCan = useRoleCan({ roles: ['administrador', 'operacional'] });
  const isClient = useRoleCan({ roles: ['cliente'] });
  const isCommercialPartner = useRoleCan({ roles: ['parceiro comercial'] });
  const { groups, headOffices, branches } = useContext(FilterContext);

  const toast = useToast();
  const [listaGerentes, setListaGerentes] = useState<UsersContact[]>([]);
  const [listaParceiros, setListaParceiros] = useState<UsersContact[]>([]);
  const [listaCustomerSuccess, setListaCustomerSuccess] = useState<
    UsersContact[]
  >([]);
  const [isLoadingDownload, setIsLoadingDownload] = useState(false);
  const [isDownloadingContracts, setIsDownloadingContracts] = useState(false);
  const {
    data: invoices,
    isLoading: invoicesLoading,
    isFetching: invoicesIsFetching,
    error: invoicesError,
    refetch: invoicesRefetch,
  } = useInvoices(
    1,
    '',
    '2',
    '',
    '',
    'dt_emissaofatura',
    'DESC',
    { groups: [], branches: [], headOffices: [] },
    PAGE_SIZE,
    {},
  );
  // refactor home
  const {
    data: pieChart,
    isLoading: isLoadingPiechart,
    isError: isErrorPiechart,
    isFetching: isFetchingPiechart,
  } = usePieChart('');
  const {
    data: contratosEmAndamento,
    isLoading: isLoadingContratosEmAndamento,
    isError: isErrorContratosEmAndamento,
    isFetching: isFetchingContratosEmAndamento,
  } = useContratosEmAndamento('');
  const {
    data: clientes,
    isLoading: isLoadingClientes,
    isError: isErrorClientes,
    isFetching: isFetchingClientes,
  } = useClientes('');
  const {
    data: faturasEmAtraso,
    isLoading: isLoadingFaturasEmAtraso,
    isError: isErrorFaturasEmAtraso,
    isFetching: isFetchingFaturasEmAtraso,
  } = useFaturasEmAtraso('');
  const {
    data: contratosAguardandoReajuste,
    isLoading: isLoadingContratosAguardandoReajuste,
    isError: isErrorContratosAguardandoReajuste,
    isFetching: isFetchingContratosAguardandoReajuste,
  } = useContratosAguardandoReajuste('');
  const {
    data: contratos90dias,
    isLoading: isLoadingContratos90dias,
    isError: isErrorContratos90dias,
    isFetching: isFetchingContratos90dias,
  } = useContratos90Dias('');
  const {
    data: equipamentosContratados,
    isLoading: isLoadingEquipamentosContratados,
    isError: isErrorEquipamentosContratados,
    isFetching: isFetchingEquipamentosContratados,
  } = useEquipamentosContratados('');
  const {
    data: valoresFaturados,
    isLoading: isLoadingValoresFaturados,
    isError: isErrorValoresFaturados,
    isFetching: isFetchingValoresFaturados,
  } = useValoresFaturados('');
  const {
    data: apolicesAVencer,
    isLoading: isLoadingApolicesAVencer,
    isError: isErrorApolicesAVencer,
    isFetching: isFetchingApolicesAVencer,
  } = useApolicesAVencer(pageInsurance);

  const [isMounted, setIsMounted] = useState(true);
  useEffect(() => {
    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    setPage(1);
    setPageInsurance(1);
    refetch();
  }, [groups, headOffices, branches]);

  const safeRender = (callback: () => ReactNode): ReactNode => {
    return isMounted ? callback() : null;
  };

  const { isOpen, onOpen, onClose } = useDisclosure();

  const breakpoints = {
    base: '0px',
    sm: '320px',
    md: '768px',
    lg: '960px',
    xl: '1285px',
    '2xl': '1536px',
  };

  const theme = extendTheme({ breakpoints });

  const setAlertLocalStorage = (viewed: boolean) => {
    localStorage.setItem(`${STORAGE}:alertViewed`, String(viewed));
  };

  const {
    data: invoicesData,
    isLoading: isLoadingInvoices,
    isError: isErrorOnInvoices,
    isFetching: isFetchingInvoices,
    refetch,
  } = useHomeInvoices(page);

  useEffect(() => {
    if (isClient) {
      getHomeContacts().then(r => {
        setListaGerentes(r.gerentes);
        setListaParceiros(r.parceiros);
        setListaCustomerSuccess(r.customer_success);
      });
    }
  }, []);

  useEffect(() => {
    const viewedStoraged = localStorage.getItem(`${STORAGE}:alertViewed`);
    const viewed = viewedStoraged === 'true';
    if (invoices?.results?.length && !viewed) {
      onOpen();
    }
  }, [invoices]);

  const verFaturas = () => {
    onClose();
    setAlertLocalStorage(true);
    history.push(`${ROUTER_PATHS.PORTAL.INVOICES}?situacao=2`);
  };

  const ignorarFaturas = () => {
    onClose();
    setAlertLocalStorage(true);
  };

  const handleDownload = async (id: string, status: number) => {
    setIsLoadingDownload(true);
    getExtensionContractDocument(id, status)
      .then(r => {
        if (r.data.size > 0) {
          download(
            new Blob([r.data], { type: r.data.type }),
            r.headers['content-disposition'].match(/filename="(.+)"/)[1],
          );
        } else {
          toast({
            title: r?.data?.error,
            description: 'Entre em contato para mais informações',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        }
        setIsLoadingDownload(false);
      })
      .catch(err => {
        toast({
          title: `Erro`,
          description: err.message,
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        setIsLoadingDownload(false);
      });
  };

  const extendsOrAlert = (contrato: Contract) => {
    if (contrato.status_proposta === 1) {
      if (!contrato.possui_faturas_atraso) {
        return (
          <Link
            style={{
              pointerEvents: 'auto',
              display: 'inline-block',
              marginRight: '10px',
              color: 'inherit',
            }}
            to={`/portal/contracts-extension/${contrato.id_contrato}`}
            color="inherit"
          >
            <Text
              color="#065DD0"
              _hover={{
                color: '#065DD0',
                textDecoration: 'underline',
              }}
              fontWeight={500}
            >
              Estender Contrato
            </Text>
          </Link>
        );
      }
      return (
        <Tooltip
          hasArrow
          label="Pagamento pendente"
          bg="black"
          shouldWrapChildren
        >
          <Icon as={FiInfo} color="red" />
        </Tooltip>
      );
    }
    return null;
  };

  const possuiContatos =
    listaGerentes?.length ||
    listaParceiros?.length ||
    listaCustomerSuccess?.length;

  const handleDownloadContractsXlsx = async () => {
    setIsDownloadingContracts(true);
    const arrGroups = groups.map(e => e.value);
    const arrHeadOffices = headOffices.map(e => e.value);
    const arrBrancches = branches.map(e => e.value);
    getHomeContractsXlsx({
      groups: arrGroups,
      headoffices: arrHeadOffices,
      branches: arrBrancches,
    })
      .then(r => {
        if (r.data.size > 0) {
          download(
            new Blob([r.data], { type: r.data.type }),
            r.headers['content-disposition'].match(/filename="(.+)"/)[1],
          );
        } else {
          toast({
            title: r?.data?.error,
            description: 'Entre em contato para mais informações',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        }
      })
      .catch(async err => {
        const error2 = JSON.parse(await err.response.data.text());
        toast({
          title: `Erro`,
          description: error2.detail,
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .finally(() => setIsDownloadingContracts(false));
  };

  const getContatos = () => {
    if (isClient) {
      if (possuiContatos) {
        return (
          <Stack w="100%" gridGap={3} mt={4}>
            <Heading style={{ marginTop: '15px' }}>
              Precisa de ajuda? Fale com a gente:
            </Heading>
            <SimpleGrid
              columns={{ base: 1, sm: 1, md: 2, xl: 3, '2xl': 3 }}
              spacing={5}
            >
              {listaGerentes?.length > 0 &&
                listaGerentes.map(res => {
                  return (
                    <ContactUsCards contatoUsuario={res} key={res.email} />
                  );
                })}
              {listaCustomerSuccess?.length > 0 &&
                listaCustomerSuccess.map(res => {
                  return (
                    <ContactUsCards
                      contatoUsuario={res}
                      key={res.email}
                      possuiTelefone={false}
                    />
                  );
                })}
              {listaParceiros?.length > 0 &&
                listaParceiros.map(res => {
                  return (
                    <ContactUsCards contatoUsuario={res} key={res.email} />
                  );
                })}
            </SimpleGrid>
          </Stack>
        );
      }
      return (
        <Stack w="100%" gridGap={3}>
          <Heading>Precisa de ajuda? Fale com a gente:</Heading>
          <SimpleGrid columns={3} spacing={5}>
            <ContactUsCards existeContatos={false} />
          </SimpleGrid>
        </Stack>
      );
    }
    return null;
  };

  return (
    <Flex flexDir="column" justify="space-between">
      <Box px="8" py="4">
        <Flex
          pt={6}
          justifyContent="space-between"
          spacing={3}
          flexWrap="wrap"
          width="100%"
        >
          {safeRender(() => (
            <HStack
              minW={{
                base: '100%',
                md: '100%',
                xl: '100%',
                '2xl': '100%',
              }}
            >
              <Flex
                w="100%"
                direction="row"
                spacing={5}
                justifyContent="space-between"
              >
                <SummaryActivities
                  title="Clientes ativos"
                  value={clientes || 0}
                  image={contractImg}
                  variant="blue"
                />
                <SummaryActivities
                  title="Contratos ativos"
                  value={contratosEmAndamento || 0}
                  isLink
                  to="/portal/contracts?situacao=1"
                  image={paperImg}
                  variant="green"
                />
                <SummaryActivities
                  title="Contratos a vencer"
                  value={contratos90dias?.contratosAVencer || 0}
                  image={paperTimeImg}
                  variant="dark-blue"
                />
                <SummaryActivities
                  title="Faturas não pagas"
                  value={faturasEmAtraso || 0}
                  image={dollarImg}
                  variant="red"
                  warning
                />
                <SummaryActivities
                  title="Contratos em reajuste"
                  value={contratosAguardandoReajuste || 0}
                  isLink
                  image={paperPenImg}
                  variant="yellow"
                  to="/portal/contracts?situacaoFaturamento=1"
                  warning
                />
                <SummaryActivities
                  title="Equipamentos contratados"
                  value={equipamentosContratados || 0}
                  image={equipamentsImg}
                  variant="purple"
                  imageSize="60px"
                />
              </Flex>
            </HStack>
          ))}
        </Flex>
        <Stack
          minW={{ base: '100%', md: '100%', xl: '100%', '2xl': '100%' }}
          pt={5}
        >
          <Flex pt={2} flexDir="column" w="100%">
            <Heading fontSize="xl" mb={0}>
              Valores faturados
            </Heading>
          </Flex>
          {safeRender(() => (
            <TableContainer overflowY="scroll" maxHeight="calc(50vh + 42px)">
              <Table type="secondary">
                <Thead>
                  <Tr>
                    <Th w="10%" p="0.5rem !important">
                      {' '}
                      {isLoadingValoresFaturados && (
                        <Spinner style={{ marginLeft: '10px' }} />
                      )}
                    </Th>
                    {valoresFaturados?.months.map(item => (
                      <Th w="10%" p="0.5rem !important" textAlign="end">
                        {item}
                      </Th>
                    ))}
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td p="0.5rem !important" style={{ fontWeight: 'bold' }}>
                      Valor faturado
                    </Td>
                    {valoresFaturados?.total_faturado.map(item => (
                      <Td
                        p="0.5rem !important"
                        textAlign="end"
                        style={{ fontWeight: 'bold' }}
                      >
                        {item}
                      </Td>
                    ))}
                  </Tr>
                  <Tr>
                    <Td style={{ fontWeight: 'bold' }}>Contratos iniciais</Td>
                    {valoresFaturados?.total_contratos_iniciais.map(item => (
                      <Td p="0.5rem !important" textAlign="end">
                        {item}
                      </Td>
                    ))}
                  </Tr>
                  <Tr>
                    <Td style={{ fontWeight: 'bold' }}>Contratos estendidos</Td>
                    {valoresFaturados?.total_contratos_estendidos.map(item => (
                      <Td p="0.5rem !important" textAlign="end">
                        {item}
                      </Td>
                    ))}
                  </Tr>
                  <Tr>
                    <Td p="0.5rem !important" style={{ fontWeight: 'bold' }}>
                      Valor pago
                    </Td>
                    {valoresFaturados?.total_pago.map(item => (
                      <Td
                        p="0.5rem !important"
                        textAlign="end"
                        style={{ fontWeight: 'bold' }}
                      >
                        {item}
                      </Td>
                    ))}
                  </Tr>
                  <Tr>
                    <Td p="0.5rem !important" style={{ fontWeight: 'bold' }}>
                      Valor em aberto
                    </Td>
                    {valoresFaturados?.total_em_aberto.map(item => (
                      <Td
                        p="0.5rem !important"
                        textAlign="end"
                        style={{ fontWeight: 'bold' }}
                      >
                        {item}
                      </Td>
                    ))}
                  </Tr>
                </Tbody>
              </Table>
            </TableContainer>
          ))}
        </Stack>
        <Stack
          minW={{ base: '100%', md: '100%', xl: '100%', '2xl': '100%' }}
          pt={5}
        >
          <Flex pt={2} flexDir="column" w="100%">
            <Flex justify="space-between" py={3}>
              <Flex align="end" gridGap={4}>
                <Heading fontSize="xl" mb={0}>
                  Contratos a encerrar
                </Heading>
              </Flex>
              <Button
                disabled={isDownloadingContracts}
                leftIcon={<FiDownload />}
                onClick={handleDownloadContractsXlsx}
                color="black"
                background="white"
                _hover={{
                  bgColor: 'white',
                }}
                style={{ height: '20px' }}
              >
                Exportar
                {isDownloadingContracts && (
                  <Spinner style={{ marginLeft: '10px' }} />
                )}
              </Button>
            </Flex>
          </Flex>
          <TableContainer overflowY="scroll" maxHeight="calc(50vh + 42px)">
            <Table type="secondary">
              <Thead>
                <Tr>
                  <Th w="6%" p="0.5rem !important">
                    N° Contrato
                  </Th>
                  <Th w="10%" p="0.5rem !important">
                    N° Pedido Locação
                  </Th>
                  <Th w="30%" p="0.5rem !important">
                    Empresa/Grupo
                  </Th>
                  <Th w="10%" whiteSpace="break-spaces" p="0.5rem !important">
                    Validade do Contrato
                  </Th>
                  <Th w="8%" p="0.5rem !important" textAlign="end">
                    Valor mensal
                  </Th>
                  {ALL_FEATURES && !isCommercialPartner && (
                    <>
                      <Th w="10%" p="0.5rem !important">
                        Status
                      </Th>
                      <Th p="0.5rem !important" w="5%" textAlign="center">
                        Ação
                      </Th>
                    </>
                  )}
                </Tr>
              </Thead>
              <Tbody>
                {safeRender(() =>
                  contratos90dias?.contratos90dias.length ? (
                    contratos90dias?.contratos90dias.map(contract => (
                      <Tr key={contract.id_contrato}>
                        <Td
                          p="0.5rem !important"
                          style={{ borderColor: '#e5e5e6' }}
                        >
                          <ChakraButton
                            variant="link"
                            fontWeight="bold"
                            color="#78797A"
                            onClick={() =>
                              history.push(
                                replaceParameters(
                                  ROUTER_PATHS.PORTAL.CONCTRACT_DETAIL,
                                  String(contract.id_contrato),
                                ),
                              )
                            }
                            fontSize="15px"
                            textDecoration="underline"
                          >
                            {contract.nu_contrato}
                          </ChakraButton>
                        </Td>
                        <Td
                          p="0.5rem !important"
                          style={{ borderColor: '#e5e5e6' }}
                        >
                          <Tooltip
                            label={contract.nu_pedido}
                            placement="top-start"
                          >
                            {contract.nu_pedido ?? '-'}
                          </Tooltip>
                        </Td>
                        <Td
                          fontSize="15px"
                          whiteSpace="nowrap"
                          overflow="hidden"
                          textOverflow="ellipsis"
                          maxWidth="200px"
                          p="0.5rem !important"
                          style={{ borderColor: '#e5e5e6' }}
                        >
                          <Tooltip
                            label={contract.empresa?.nm_fantasia}
                            placement="top-start"
                          >
                            {contract.empresa?.nm_fantasia ?? '-'}
                          </Tooltip>
                          <Text
                            fontSize="11px"
                            fontWeight="500"
                            overflow="hidden"
                            textOverflow="ellipsis"
                          >
                            <Tooltip
                              label={contract.empresa?.nm_grupoeconomico}
                              placement="top-start"
                            >
                              {contract.empresa?.nm_grupoeconomico ?? '-'}
                            </Tooltip>
                          </Text>
                        </Td>

                        <Td
                          fontSize="13px"
                          p="0.5rem !important"
                          style={{ borderColor: '#e5e5e6' }}
                        >
                          <Text>
                            <b>Prazo: </b>
                            {contract.prazo_contrato ?? '-'}
                          </Text>
                          <Text>
                            <b>Encerramento: </b>
                            {contract.mes_encerramentocontrato ?? '-'}
                          </Text>
                        </Td>
                        <Td
                          textAlign="end"
                          p="0.5rem !important"
                          style={{ borderColor: '#e5e5e6' }}
                        >
                          {contract.formattedMensalAtualValue ?? '-'}
                        </Td>
                        {ALL_FEATURES && !isCommercialPartner && (
                          <>
                            <Td
                              p="0.5rem !important"
                              style={{ borderColor: '#e5e5e6' }}
                            >
                              <StatusBadge
                                variant={contract.statusColorScheme}
                                width="fit-content"
                              >
                                {contract.formattedStatus}
                              </StatusBadge>
                            </Td>
                            <Td
                              textAlign="center"
                              style={{ borderColor: '#e5e5e6' }}
                            >
                              <HStack justifyContent="center">
                                {features.analiseAutomaticaExtensaoEnabled &&
                                  internoCan &&
                                  (contract?.status_proposta ===
                                    StatusExtensaoIdEnum.AGUARDANDO_ANALISE_EXTENSAO ||
                                    contract?.status_proposta ===
                                      StatusExtensaoIdEnum.ELEGIVEL_EXTENSAO_ANALISE_AUTOMATICA ||
                                    contract?.status_proposta ===
                                      StatusExtensaoIdEnum.NAO_ELEGIVEL_EXTENSAO_ANALISE_AUTOMATICA) && (
                                    <Flex
                                      width="60px"
                                      justifyContent="space-between"
                                    >
                                      <AnalyseContractExtensionModal
                                        id_contrato={contract.id_contrato}
                                        trigger={
                                          <ChakraButton
                                            px={3}
                                            fontSize="14px"
                                            variant="link"
                                          >
                                            {contract.status_proposta ===
                                            StatusExtensaoIdEnum.AGUARDANDO_ANALISE_EXTENSAO
                                              ? 'Solicitar'
                                              : 'Revisar'}
                                          </ChakraButton>
                                        }
                                      />
                                      {(contract?.status_proposta ===
                                        StatusExtensaoIdEnum.ELEGIVEL_EXTENSAO_ANALISE_AUTOMATICA ||
                                        contract?.status_proposta ===
                                          StatusExtensaoIdEnum.NAO_ELEGIVEL_EXTENSAO_ANALISE_AUTOMATICA) && (
                                        <Tooltip
                                          hasArrow
                                          label={`${
                                            contract?.status_proposta ===
                                            StatusExtensaoIdEnum.NAO_ELEGIVEL_EXTENSAO_ANALISE_AUTOMATICA
                                              ? 'NÃO'
                                              : ''
                                          } ELEGÍVEL PARA EXTENSÃO PELA ANÁLISE AUTOMÁTICA`}
                                          bg="black"
                                          shouldWrapChildren
                                        >
                                          <Icon as={FiInfo} />
                                        </Tooltip>
                                      )}
                                    </Flex>
                                  )}
                                {externoCan && (
                                  <Text>{extendsOrAlert(contract)}</Text>
                                )}
                                {contract.possui_termo_extensao && (
                                  <Tooltip
                                    hasArrow
                                    label="Baixar termo"
                                    placement="top-start"
                                    bg="gray"
                                  >
                                    <IconButton
                                      colorScheme="gray"
                                      aria-label="Download termo"
                                      icon={
                                        isLoadingDownload ? (
                                          <Spinner />
                                        ) : (
                                          <Icon as={FiDownload} />
                                        )
                                      }
                                      isDisabled={isLoadingDownload}
                                      onClick={() => {
                                        handleDownload(
                                          contract.id_contrato,
                                          contract.status_proposta
                                            ? contract.status_proposta
                                            : 0,
                                        );
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </HStack>
                            </Td>
                          </>
                        )}
                      </Tr>
                    ))
                  ) : (
                    <Tr>
                      {isLoadingContratos90dias ? (
                        <Td>
                          <Spinner style={{ marginLeft: '10px' }} />
                        </Td>
                      ) : (
                        <Td>Não há dados a serem apresentados</Td>
                      )}
                    </Tr>
                  ),
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </Stack>
        <Flex
          flexWrap="wrap"
          w="100%"
          pt={5}
          pb={5}
          style={{
            position: 'relative',
          }}
        >
          <HStack
            width="100%"
            height="100%"
            flexWrap="wrap"
            justifyContent="space-between"
            gridGap={2}
            align="unset"
          >
            <Stack
              minW={{ base: '100%', md: '100%', xl: '100%', '2xl': '68%' }}
              marginStart="0 !important"
              height="100%"
            >
              <Heading fontSize="xl" mb={0}>
                Faturas não pagas
              </Heading>
              <TableContainer
                overflowY="scroll"
                overflowX="unset"
                maxHeight="300px"
              >
                <Table type="secondary">
                  <Thead>
                    <Tr>
                      <Th p="0.5rem !important" w="10%">
                        N° Fatura
                      </Th>
                      <Th p="0.5rem !important" w="10%">
                        Vencimento
                      </Th>
                      <Th p="0.5rem !important">Empresa</Th>
                      <Th p="0.5rem !important" w="15%">
                        Grupo
                      </Th>
                      <Th p="0.5rem !important" textAlign="end" w="15%">
                        Valor
                      </Th>
                      <Th p="0.5rem !important" w="10%">
                        Status
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {safeRender(() =>
                      invoicesData?.results.length ? (
                        invoicesData?.results.map(invoice => (
                          <Tr key={invoice.id_fatura}>
                            <Td
                              p="0.5rem !important"
                              style={{ borderColor: '#e5e5e6' }}
                            >
                              <ChakraButton
                                variant="link"
                                fontWeight="bold"
                                color="#78797A"
                                onClick={() =>
                                  history.push(
                                    replaceParameters(
                                      ROUTER_PATHS.PORTAL.INVOICES_DETAIL,
                                      String(invoice.id_fatura),
                                    ),
                                  )
                                }
                                fontSize="15px"
                                textDecoration="underline"
                              >
                                {invoice.nu_fatura}
                              </ChakraButton>
                            </Td>
                            <Td
                              fontSize="15px"
                              p="0.5rem !important"
                              style={{ borderColor: '#e5e5e6' }}
                            >
                              {invoice.formattedDueDate ?? '-'}
                            </Td>
                            <Td
                              fontSize="15px"
                              whiteSpace="nowrap"
                              overflow="hidden"
                              textOverflow="ellipsis"
                              maxWidth="200px"
                              p="0.5rem !important"
                              style={{ borderColor: '#e5e5e6' }}
                            >
                              <Tooltip
                                label={invoice.nm_empresa}
                                placement="top-start"
                              >
                                {invoice.nm_empresa ?? '-'}
                              </Tooltip>
                            </Td>
                            <Td
                              fontSize="15px"
                              whiteSpace="nowrap"
                              overflow="hidden"
                              textOverflow="ellipsis"
                              maxWidth="200px"
                              p="0.5rem !important"
                              style={{ borderColor: '#e5e5e6' }}
                            >
                              <Text>
                                <Tooltip
                                  label={invoice.nm_grupo}
                                  placement="top-start"
                                >
                                  {invoice.nm_grupo ?? '-'}
                                </Tooltip>
                              </Text>
                            </Td>
                            <Td
                              fontSize="15px"
                              p="0.5rem !important"
                              textAlign="end"
                              style={{ borderColor: '#e5e5e6' }}
                            >
                              {invoice.formattedValue}
                            </Td>
                            <Td
                              p="0.5rem !important"
                              style={{ borderColor: '#e5e5e6' }}
                            >
                              <StatusBadge variant={invoice.colorScheme}>
                                {invoice.formattedStatus}
                              </StatusBadge>
                            </Td>
                          </Tr>
                        ))
                      ) : (
                        <Tr>
                          {isLoadingInvoices || isFetchingInvoices ? (
                            <>
                              <Td> </Td>
                              <Td align="center" valign="middle" h="100%">
                                <Spinner />
                              </Td>
                              <Td> </Td>
                              <Td> </Td>
                            </>
                          ) : (
                            <Td align="center" valign="middle" h="100%">
                              Não há dados a serem apresentados
                            </Td>
                          )}
                        </Tr>
                      ),
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
              <Flex
                justify="flex-end"
                minHeight="32px"
                height="32px"
                marginTop="10px !important"
                align="baseline"
              >
                {invoicesData && (
                  <Pagination
                    totalCountOfRegisters={invoicesData?.count}
                    currentPage={page}
                    onPageChange={setPage}
                    registersPerPage={50}
                    marginTop="0"
                  />
                )}
              </Flex>
            </Stack>
            <Stack
              minW={{
                base: '100%',
                md: '100%',
                xl: '30%',
                '2xl': '30%',
              }}
            >
              <Spacer />
              <Flex p={0} justify="center" pb="30px">
                <Box placement="right" justify="right" ps={0}>
                  <Stack gridGap={3} placement="right" justify="right">
                    {!isLoadingPiechart ? (
                      <Flex gridGap={2}>
                        <Chart
                          width="440px"
                          height="300px"
                          chartType="PieChart"
                          loader={<div>Carregando...</div>}
                          data={pieChart}
                          options={{
                            pieSliceText: 'value',
                            legend: { position: 'left' },
                            chartArea: {
                              left: 10,
                              top: 20,
                              bottom: 10,
                              width: '100%',
                              height: '100%',
                            },
                            colors: [
                              '#80c1e5',
                              '#f3af6a',
                              '#66c1b0',
                              '#a17bc6',
                              '#f293a1',
                              '#48CAE4',
                              '#DA3BAD',
                              '#FF8C05',
                              '#81C56A',
                              '#3071EF',
                            ],
                          }}
                        />
                        {!userIsOperacional && (
                          <Shortcut
                            image={shortcut}
                            text="Suporte técnico"
                            alignSelf="flex-end"
                            link={ROUTER_PATHS.PORTAL.TECHNICAL_SUPPORT}
                          />
                        )}
                      </Flex>
                    ) : (
                      <Spinner style={{ marginLeft: '10px' }} />
                    )}
                  </Stack>
                </Box>
              </Flex>
            </Stack>
          </HStack>
          {getContatos()}
        </Flex>
        {canSeeInsurances && (
          <Stack
            minW={{ base: '100%', md: '100%', xl: '100%', '2xl': '100%' }}
            pt={5}
          >
            <Flex pt={2} flexDir="column" w="100%">
              <Flex justify="space-between" py={3}>
                <Flex align="end" gridGap={4}>
                  <Heading fontSize="xl" mb={0}>
                    Apólices a vencer em 30 dias
                  </Heading>
                </Flex>
              </Flex>
              <TableContainer overflowY="scroll" maxHeight="calc(50vh + 42px)">
                <Table type="secondary">
                  <Thead>
                    <Tr>
                      <Th w="6%" p="0.5rem !important">
                        N° Contrato
                      </Th>
                      <Th w="10%" p="0.5rem !important">
                        N° Pedido Locação
                      </Th>
                      <Th w="30%" p="0.5rem !important">
                        Empresa/Grupo
                      </Th>
                      <Th
                        w="10%"
                        whiteSpace="break-spaces"
                        p="0.5rem !important"
                      >
                        N° da Apólice
                      </Th>
                      <Th w="8%" p="0.5rem !important" textAlign="center">
                        Status da Apólice
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {safeRender(() =>
                      apolicesAVencer?.results?.length ? (
                        apolicesAVencer.results.map((item: InsuranceList) => (
                          <Tr key={item.id}>
                            <Td
                              p="0.5rem !important"
                              style={{ borderColor: '#e5e5e6' }}
                            >
                              <ChakraButton
                                variant="link"
                                fontWeight="bold"
                                color="#78797A"
                                onClick={() =>
                                  history.push(
                                    replaceParameters(
                                      ROUTER_PATHS.PORTAL.CONCTRACT_DETAIL,
                                      String(item.id_contrato),
                                    ),
                                  )
                                }
                                fontSize="15px"
                                textDecoration="underline"
                              >
                                {item.nu_contrato}
                              </ChakraButton>
                            </Td>
                            <Td
                              p="0.5rem !important"
                              style={{ borderColor: '#e5e5e6' }}
                            >
                              <Tooltip
                                label={item.nu_pedido}
                                placement="top-start"
                              >
                                {item.nu_pedido ?? '-'}
                              </Tooltip>
                            </Td>
                            <Td
                              fontSize="15px"
                              whiteSpace="nowrap"
                              overflow="hidden"
                              textOverflow="ellipsis"
                              maxWidth="200px"
                              p="0.5rem !important"
                              style={{ borderColor: '#e5e5e6' }}
                            >
                              <Tooltip
                                label={item.nm_razaosocial}
                                placement="top-start"
                              >
                                {item.nm_razaosocial ?? '-'}
                              </Tooltip>
                              <Text
                                fontSize="11px"
                                fontWeight="500"
                                overflow="hidden"
                                textOverflow="ellipsis"
                              >
                                <Tooltip
                                  label={item.nm_grupoeconomico}
                                  placement="top-start"
                                >
                                  {item.nm_grupoeconomico ?? '-'}
                                </Tooltip>
                              </Text>
                            </Td>

                            <Td
                              fontSize="13px"
                              p="0.5rem !important"
                              style={{ borderColor: '#e5e5e6' }}
                            >
                              {item.nu_apolice ?? '-'}
                            </Td>
                            <Td
                              textAlign="center"
                              p="0.5rem !important"
                              style={{ borderColor: '#e5e5e6' }}
                            >
                              <StatusBadge
                                variant={item.statusColor}
                                width="fit-content"
                              >
                                {item.formattedStatus}
                              </StatusBadge>
                            </Td>
                          </Tr>
                        ))
                      ) : (
                        <Tr>
                          {isLoadingContratos90dias ? (
                            <Td>
                              <Spinner style={{ marginLeft: '10px' }} />
                            </Td>
                          ) : (
                            <Td>Não há dados a serem apresentados</Td>
                          )}
                        </Tr>
                      ),
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
              <Flex
                justify="flex-end"
                minHeight="32px"
                height="32px"
                marginTop="10px !important"
                align="baseline"
              >
                {apolicesAVencer && (
                  <Pagination
                    totalCountOfRegisters={apolicesAVencer?.count}
                    currentPage={pageInsurance}
                    onPageChange={setPageInsurance}
                    registersPerPage={50}
                    marginTop="0"
                  />
                )}
              </Flex>
            </Flex>
          </Stack>
        )}
      </Box>
      <Flex width="100%" justify="flex-end" p={4}>
        <Text color="gray.400">Versão 2.4.22</Text>
      </Flex>
      {isClient && (
        <ConfirmationDialog
          confirmar={verFaturas}
          onClose={ignorarFaturas}
          isOpen={isOpen}
          titulo="Aviso"
          btnConfirmText="Ver faturas"
          btnCancelText="Fechar"
        >
          <Text>
            Verificamos que você possui <strong>faturas vencidas</strong>. Por
            favor, regularize as pendências para manter nossos serviços.
          </Text>
          <Text>
            Se já efetuou o pagamento, por favor, ignore este aviso. Se você
            tiver alguma dúvida ou precisar de assistência, entre em contato
            conosco pelo e-mail{' '}
            <ChakraLink
              href="mailto:positivoasaservice@positivo.com.br"
              color="#5b8af0"
              textDecoration="underline"
            >
              positivoasaservice@positivo.com.br
            </ChakraLink>
            <span>.</span>
          </Text>
        </ConfirmationDialog>
      )}
    </Flex>
  );
};
